import { render, staticRenderFns } from "./YolcuBilgileri.vue?vue&type=template&id=70df5ada&"
import script from "./YolcuBilgileri.vue?vue&type=script&lang=js&"
export * from "./YolcuBilgileri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports